export const chartConfig = ({ type, onMouseOverChart, onMouseOutChart }) => {
    return {
        chart: {
            animation: false,
            type,
            plotBackgroundColor: "transparent",
            height: 140,
            width: 140,
        },
        legend: {
            enabled: false,
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            pie: {
                innerSize: "60%",
                animation: false,
                showInLegend: true,
                cursor: "pointer",
                borderWidth: 1,
                dataLabels: {
                    enabled: false,
                },
                size: 101,
            },
            series: {
                point: {
                    events: {
                        mouseOver: onMouseOverChart,
                        mouseOut: onMouseOutChart,
                    },
                },
            },
        },
    };
};
